var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGeneralInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M18.7,17H3.3A3.488,3.488,0,0,1,0,13.357V3.642A3.488,3.488,0,0,1,3.3,0H18.7A3.488,3.488,0,0,1,22,3.642v9.714A3.488,3.488,0,0,1,18.7,17ZM2.2,7.286v6.071a1.163,1.163,0,0,0,1.1,1.214H18.7a1.163,1.163,0,0,0,1.1-1.214V7.286ZM3.3,2.428A1.163,1.163,0,0,0,2.2,3.642V4.857H19.8V3.642a1.163,1.163,0,0,0-1.1-1.214Zm13.2,9.714H14.3a1.22,1.22,0,0,1,0-2.428h2.2a1.22,1.22,0,0,1,0,2.428Zm-6.6,0H5.5a1.22,1.22,0,0,1,0-2.428H9.9a1.22,1.22,0,0,1,0,2.428Z",
    fill: "#767493"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-24 -152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_general_info_deactive",
    transform: "translate(38 166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M18.7,17H3.3A3.488,3.488,0,0,1,0,13.357V3.642A3.488,3.488,0,0,1,3.3,0H18.7A3.488,3.488,0,0,1,22,3.642v9.714A3.488,3.488,0,0,1,18.7,17ZM2.2,7.286v6.071a1.163,1.163,0,0,0,1.1,1.214H18.7a1.163,1.163,0,0,0,1.1-1.214V7.286ZM3.3,2.428A1.163,1.163,0,0,0,2.2,3.642V4.857H19.8V3.642a1.163,1.163,0,0,0-1.1-1.214Zm13.2,9.714H14.3a1.22,1.22,0,0,1,0-2.428h2.2a1.22,1.22,0,0,1,0,2.428Zm-6.6,0H5.5a1.22,1.22,0,0,1,0-2.428H9.9a1.22,1.22,0,0,1,0,2.428Z",
    fill: "#767493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneralInfo);
export default __webpack_public_path__ + "static/media/icon_general-info.b3719bd597222011fd1cbfc0023b87f5.svg";
export { ForwardRef as ReactComponent };